import type { FC, ReactNode } from 'react';
import { Flex, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useResourceRoutePreview } from '@/shared/components/resource-route-preview/context';
import ResourcePreviewField from '@/shared/components/resource-route-preview/ResourcePreviewField';

interface TaskPropertyRowProps {
    children: ReactNode;
    label: string;
    field?: string;
}

const TaskPropertyRow: FC<TaskPropertyRowProps> = ({ children, field, label }): JSX.Element => {
    const { token } = useAntDesignTheme();
    const preview = useResourceRoutePreview();

    return (
        <Flex
            align='center'
            className='task-detail-property-row'
            justify='space-between'
            style={{ borderBottom: `1px solid ${token.colorBorderSecondary}` }}
            wrap='nowrap'
        >
            <Typography.Text className='task-detail-property-label' type='secondary'>
                {label}
            </Typography.Text>
            <Flex align='center' className='task-detail-property-value' justify='flex-end' wrap='nowrap'>
                {field ? (
                    <ResourcePreviewField field={field} resourceType='tasks' resourceId={preview?.resourceId}>
                        {children}
                    </ResourcePreviewField>
                ) : (
                    children
                )}
            </Flex>
        </Flex>
    );
};

export default TaskPropertyRow;
